export class SalesAnalyticsRequest {
  store: number;
  from: Date;
  to: Date;
  accountCollector: number;
  transactionStatus: string;
  tenantId: number;
}
